import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormArray, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Form } from 'src/app/models/form';

import { FormOverlay } from 'src/app/models/form-overlay';
import { FormPropertyKey } from 'src/app/models/form-property-key';

@Component({
  selector: 'app-form-overlay',
  templateUrl: './form-overlay.component.html',
  styleUrls: ['./form-overlay.component.scss']
})
export class FormOverlayComponent implements OnInit {

  Form = Form;
  FormPropertyKey = FormPropertyKey;

  @Input() formOverlay:FormOverlay;
  // @Input() isEdit:boolean = false;
  @Output() formOverlayInputed = new EventEmitter();

  formGroup:FormGroup;

  constructor() { }

  ngOnInit() {

    console.log(this.formOverlay);

    this.formGroup = new FormGroup({
      formPropertyKeys: new FormArray([])
    });

    this.updateFormPropertyKeys();

  }

  get formPropertyKeysFormArray(){
    return this.formGroup.get("formPropertyKeys") as FormArray;
  }
  formPropertyKeyFormGroup(index){
    return this.formPropertyKeysFormArray.controls[index] as FormGroup;
  }
  formPropertyKeyFormControl(index, name){
    const formGroup = this.formPropertyKeyFormGroup(index);
    return formGroup.get(name);
  }

  hasError(control:AbstractControl, validatorName){
    return control.errors ? control.errors[validatorName] as boolean : false;
  }

  // 必須チェックボックスのカスタムバリデーター
  requiredCheckboxValidator(control: AbstractControl) {
    const value = control.value;
    return value === true ? null : { required: true };
  }

  updateFormPropertyKeys(){

    // リセット
    this.formPropertyKeysFormArray.clear();

    this.formOverlay.form.formPropertyKeys.forEach((formPropertyKey) => {

      let value = null;
      const validators = [];
      if(formPropertyKey.required == FormPropertyKey.RequiredTrue){
        // 単一チェックボックスの場合はカスタムバリデーターを使用
        if(formPropertyKey.inputType == FormPropertyKey.InputTypeSingleCheckbox){
          validators.push(this.requiredCheckboxValidator);
        } else {
          validators.push(Validators.required);
        }
      }

      if(formPropertyKey.inputType == FormPropertyKey.InputTypeText){
        value = formPropertyKey.defaultValue ? formPropertyKey.defaultValue : null;
        validators.push(Validators.maxLength(FormPropertyKey.InputTypeTextMaxLength));
      }
      else if(formPropertyKey.inputType == FormPropertyKey.InputTypeTextarea){
        value = formPropertyKey.defaultValue ? formPropertyKey.defaultValue : null;
        validators.push(Validators.maxLength(FormPropertyKey.InputTypeTextareaMaxLength));
      }
      else if(formPropertyKey.inputType == FormPropertyKey.InputTypeEmail){
        value = formPropertyKey.defaultValue ? formPropertyKey.defaultValue : null;
        validators.push(Validators.email);
      }
      else if(formPropertyKey.inputType == FormPropertyKey.InputTypeSelectDropdown){
        const option = formPropertyKey.options.find(option => option.isDefault == 1);
        if(option){
          value = option.value;
        }
      }
      else if(formPropertyKey.inputType == FormPropertyKey.InputTypeSingleCheckbox){
        value = formPropertyKey.defaultValue === '1' ? true : false;
      }
      else if(formPropertyKey.inputType == FormPropertyKey.InputTypeHidden){
        value = formPropertyKey.defaultValue ? formPropertyKey.defaultValue : null;
      }

      const formPropertyKeyGroup = new FormGroup({
        value: new FormControl(value, validators),
      });

      this.formPropertyKeysFormArray.push(formPropertyKeyGroup);
    });

  }

  getFormPropertyKey(index){
    return this.formOverlay.form.formPropertyKeys[index] ?? null;
  }


  done(){

    if(this.formGroup.invalid){
      return;
    }

    // formControlのvalueをformPropertyにセット
    this.formPropertyKeysFormArray.controls.forEach((control, index) => {
      const formPropertyKey = this.getFormPropertyKey(index);
      if(! formPropertyKey){
        return;
      }
      let value = control.get("value").value;
      
      // 単一チェックボックスの場合、boolean値を文字列に変換
      if(formPropertyKey.inputType == FormPropertyKey.InputTypeSingleCheckbox){
        value = value ? '1' : '0';
      }
      
      formPropertyKey.value = value;
    });

    this.formOverlayInputed.emit(this.formOverlay);
  }

  skip(){
    this.formOverlayInputed.emit(null);
  }

}
